/**
 * Accordion for the "Alle" search results view: one category open at a
 * time, the rest collapsed. Unlike AbxLexikon's fixed-height entries, result
 * lists vary a lot in length, so height is measured per entry (scrollHeight)
 * instead of capped.
 *
 * @return {void}
 */
export default function InitSearchCategoryAccordion() {
    document.querySelectorAll('.search-category-accordion').forEach(function (panel) {
        const entries = Array.from(panel.querySelectorAll('[data-search-category-entry]'));
        if (!entries.length) return;

        const open = (entry) => {
            entry.classList.add('is-active');
            entry.querySelector('[data-action="searchCategoryToggle"]')?.setAttribute('aria-expanded', 'true');
            const outer = entry.querySelector('.search-category-accordion__content-outer');
            if (outer) outer.style.maxHeight = outer.scrollHeight + 'px';
        };

        const close = (entry) => {
            const outer = entry.querySelector('.search-category-accordion__content-outer');
            if (outer) outer.style.maxHeight = '0px';
            entry.classList.remove('is-active');
            entry.querySelector('[data-action="searchCategoryToggle"]')?.setAttribute('aria-expanded', 'false');
        };

        entries.forEach(function (entry) {
            entry.querySelector('[data-action="searchCategoryToggle"]')?.addEventListener('click', function () {
                if (entry.classList.contains('is-active')) {
                    close(entry);
                } else {
                    entries.forEach((other) => other !== entry && close(other));
                    open(entry);
                }
            });
        });

        const initiallyActive = entries.find((entry) => entry.classList.contains('is-active'));
        if (initiallyActive) {
            open(initiallyActive);
            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(function () {
                    if (initiallyActive.classList.contains('is-active')) {
                        open(initiallyActive);
                    }
                });
            }
        }
    });
}
